import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core';
import Fab from '@material-ui/core/Fab';
import Icon from '@material-ui/core/Icon';

import roleDisabled from 'services/roleDisabled/index';

const propTypes = {
  size: PropTypes.string.isRequired,
  userAccess: PropTypes.arrayOf(PropTypes.string).isRequired,
  allowedAccess: PropTypes.arrayOf(PropTypes.string).isRequired,
  onClick: PropTypes.func.isRequired,
  invalidField: PropTypes.bool,
  classes: PropTypes.shape({}).isRequired,
  clear: PropTypes.bool,
  tooltip: PropTypes.string,
};

const defaultProps = {
  invalidField: false,
  clear: false,
  tooltip: '',
};

export function UnstyledRBACDeleteButton({
  size,
  userAccess,
  allowedAccess,
  onClick,
  invalidField,
  classes,
  clear,
  tooltip,
}) {
  const hoverOverride = clear ? 'none' : 'red';
  const theButton = (disabled = false) => (
    <Fab
      data-testid="deleteButton"
      size={size}
      hover-override={hoverOverride}
      classes={clear ? { root: classes.clearButton } : { root: classes.listItemDeleteRoot }}
      onClick={onClick}
      disabled={disabled || invalidField}
    >
      <Icon>delete</Icon>
    </Fab>
  );
  let formattedButton;
  if (roleDisabled(userAccess, allowedAccess)) {
    formattedButton = (
      <Tooltip title="You do not have the required access for this resource. Contact your organization owner.">
        {theButton(true)}
      </Tooltip>
    );
  } else if (tooltip && !invalidField) {
    formattedButton = (
      <Tooltip placement="left" title={tooltip}>
        {theButton()}
      </Tooltip>
    );
  } else if (tooltip && invalidField) {
    formattedButton = (
      <Tooltip placement="left" title={tooltip}>
        <span>{theButton()}</span>
      </Tooltip>
    );
  } else {
    formattedButton = theButton();
  }

  return <React.Fragment>{formattedButton}</React.Fragment>;
}

const styles = (theme) => ({
  clearButton: {
    color: theme.customColors.red,
    backgroundColor: 'inherit',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: 'inherit',
    },
  },
  listItemDeleteRoot: {
    color: theme.customColors.white,
    backgroundColor: theme.customColors.red,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: theme.customColors.red,
    },
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.26)',
      backgroundColor: 'rgba(0, 0, 0, 0.12)',
    },
  },
});

UnstyledRBACDeleteButton.propTypes = propTypes;
UnstyledRBACDeleteButton.defaultProps = defaultProps;

export default withStyles(styles)(UnstyledRBACDeleteButton);
